import { Pipe, PipeTransform } from '@angular/core';

import * as moment from 'moment';

@Pipe({ name: 'dateFormat', standalone: true })
export class DateFormatPipe implements PipeTransform {
  transform(value, dateFormat: string): any {
    return moment(value).format(dateFormat);
  }
}

// value: Date | moment.Moment
